import React, { useRef, useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

// کامپوننت‌های لندینگ
import HealthSensors from "../components/landing/HealthSensors/index.tsx";
import PersonaGrid from "../components/landing/PersonaGrid";
import FinalCTA from "../components/landing/FinalCTA";
import ComparisonSlider from "@/components/landing/ComparisonSlider";
import Testimonials from "@/components/Testimonials";
import { useRingTestimonials } from "../testimonialsData/ringTestimonials"; 
import HeroSection from "@/components/landing/RingHeroSection";
import CuratedProductShowcase from "@/components/landing/CuratedProductShowcase";
import EnhancedFAQ from "../components/landing/FAQSection";
import RingHardwareFeatures from "@/components/landing/deta-HardwareFeatures/RingHardwareFeatures";
import LifestyleUseCasesRing from "@/components/landing/deta-LifestyleUseCases/LifestyleUseCasesRing";
import { motion } from "framer-motion";
import SmartRingComparison from "@/components/landing/SmartRingComparison";

import { ringFaqs } from "../components/landing/deta-FAQ/ringFaqs";
import AIAssistantSection from "@/components/landing/AIAssistantSection";
import { Helmet } from "react-helmet-async";

const RingsPage = () => {
    const productComparisonRef = useRef(null);
    const [triggerAnimation, setTriggerAnimation] = useState(0);

    // ✅ استفاده از Hook چند زبانه
    const ringTestimonials = useRingTestimonials();

    // Structured Data
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Product",
        name: "حلقه هوشمند دلبند",
        description: "حلقه هوشمند با قابلیت‌های جامع نظارت بر سلامت و فعالیت",
        brand: {
            "@type": "Brand",
            name: "دلبند",
        },
        category: "حلقه هوشمند",
    };

    const scrollToProductComparison = () => {
        if (productComparisonRef.current) {
            // تاخیر کوتاه برای انیمیشن بهتر
            setTimeout(() => {
                (productComparisonRef.current as unknown as HTMLElement).scrollIntoView({
                    behavior: "instant", // بدون نمایش اسکرول
                    block: "start",
                });

                // trigger کردن انیمیشن با تغییر key
                setTimeout(() => {
                    setTriggerAnimation((prev) => prev + 1);
                }, 100);
            }, 300);
        }
    };

    return (
        <>
            <Helmet>
                <title>حلقه هوشمند دلبند - سلامتی و آرامش در دستان شما</title>
                <meta name="description" content="حلقه هوشمند دلبند با طراحی زیبا و قابلیت‌های پیشرفته نظارت بر سلامت، کیفیت خواب و فعالیت‌های روزانه. تجربه‌ای نوین از سلامتی." />
                <meta name="keywords" content="حلقه هوشمند, نظارت سلامت, ردیاب فعالیت, کیفیت خواب, سلامتی روزانه" />
                <link rel="canonical" href="https://delband.com/rings" />
                <meta property="og:title" content="حلقه هوشمند دلبند - سلامتی و آرامش در دستان شما" />
                <meta property="og:url" content="https://delband.com/rings" />
                <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
            </Helmet>
            <div className="bg-[#F8F9FC] relative w-full overflow-x-clip">
                <Header />
                <main className="container mx-auto px-2 pb-8 pt-26 sm:pt-24 md:pt-21 max-w-7xl overflow-x-clip">
                    <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-gradient-to-br from-[#0038A8] to-[#0072CE] rounded-full blur-[120px] opacity-25 z-0 pointer-events-none"></div>
                    <div className="absolute bottom-0 left-[-14%] w-[300px] h-[300px] bg-gray-600 rounded-full blur-[120px] opacity-15 sm:opacity-25 z-[999999] pointer-events-none"></div>

                    {/* بخش قهرمان */}
                    <HeroSection onCompareClick={scrollToProductComparison} />

                    {/* بخش سنسورهای سلامت */}
                    <HealthSensors />

                    {/* بخش ویژگی‌های سخت‌افزاری */}
                    <RingHardwareFeatures />
                    <AIAssistantSection />
                    
                    {/* بخش کاربردهای روزمره */}
                    <LifestyleUseCasesRing />

                    <PersonaGrid />



                    <ComparisonSlider
                        productType="ring"
                        leftId="EVR-X3"
                        rightId="EVR-X5"
                    />

                                        {/* ویترین اسلایدی ۴ محصول اختصاصی */}
                    <CuratedProductShowcase
                        productType="ring"
                        onCompareClick={scrollToProductComparison}
                        titleRegular="ویترین منتخب"
                        titleHighlighted="حلقه‌های هوشمند دلبند"
                        descriptionText="چهار مدل اختصاصی مهندسی‌شده با آلیاژهای لوکس و حسگرهای پیشرفته پایش سلامت و خواب"
                    />

                    {/* بخش مقایسه محصولات */}
                    <motion.div
                        key={triggerAnimation}
                        ref={productComparisonRef}
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        viewport={{ once: false, margin: "-100px" }}
                    >
                        <SmartRingComparison />
                    </motion.div>

            
                    <Testimonials data={ringTestimonials} translationNamespace="ringTestimonials" />

                    <EnhancedFAQ faqs={ringFaqs} translationNamespace="ringFAQs" />

                    <FinalCTA />
                </main>
                <Footer />
            </div>
        </>
    );
};

export default RingsPage;
